// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../../../config/screen';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 2.5rem;
  };
`;

export const LabelsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  margin: 1rem 0;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin: 0 0 1rem 0;
`;

export const EnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;
